import UserRoles from "@client.enums/userRoles";
import { isArray, isString } from "lodash";
import validate from "validate.js";

validate.validators.teamRoleValidation = function (
  value,
  options,
  key,
  attributes
) {
  if (
    [
      UserRoles.SuperAdmin,
      UserRoles.CXO,
      UserRoles.Executive,
      UserRoles.Viewer,
    ].includes(attributes.role)
  ) {
    return null;
  }

  if (!isArray(value) || value.length < 1) {
    return options.message;
  }

  return null;
};

validate.validators.domain = function (value, options) {
  if (isString(value) && value.length > 0) {
    const domainToValidate = value.split("@")[1];
    const issuerDomain = options.value.split("@")[1];
    if (
      !domainToValidate ||
      domainToValidate.toLocaleLowerCase() !== issuerDomain.toLocaleLowerCase()
    ) {
      return options.message;
    }
  }

  return null;
};

class BaseModel {
  constructor(msg) {
    this.validationMsgs = msg;
    this.validationRules = {};
  }

  validate = () => {
    const validation =
      Object.keys(this.validationRules).length === 0
        ? {}
        : validate(this, this.validationRules, {
            fullMessages: false,
          });

    return validation || {};
  };
}

export default BaseModel;
